export enum SSOAccessType {
  SSOOnly = 1,
  GovendaLoginOnly = 2,
  SSOAndGovendaLogin = 3,
}

export const getSSOAccessTypeDescription = (ssoAccessType: SSOAccessType) => {
  switch (ssoAccessType) {
    case SSOAccessType.SSOOnly:
      return 'Single Sign-On Only';
    case SSOAccessType.GovendaLoginOnly:
      return 'Govenda Sign-In Only';
    case SSOAccessType.SSOAndGovendaLogin:
      return 'Single Sign-On and Govenda Sign-In';
    default:
      return '';
  }
};